import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_6e56adae from 'nuxt_plugin_plugin_6e56adae' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_axios_593d6dc4 from 'nuxt_plugin_axios_593d6dc4' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_7921c0f7 from 'nuxt_plugin_pluginutils_7921c0f7' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_6db5ec82 from 'nuxt_plugin_pluginrouting_6db5ec82' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_23841e2d from 'nuxt_plugin_pluginmain_23841e2d' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_bugsnagclient49b55812_e84f55d8 from 'nuxt_plugin_bugsnagclient49b55812_e84f55d8' // Source: ./bugsnag.client.49b55812.js (mode: 'client')
import nuxt_plugin_nuxtpluginba874b4a_a485bdaa from 'nuxt_plugin_nuxtpluginba874b4a_a485bdaa' // Source: ./nuxt.plugin.ba874b4a.js (mode: 'all')
import nuxt_plugin_workbox_fd2cfc40 from 'nuxt_plugin_workbox_fd2cfc40' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_0192e8f3 from 'nuxt_plugin_metaplugin_0192e8f3' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_063a8e67 from 'nuxt_plugin_iconplugin_063a8e67' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_gtm_7e86d59a from 'nuxt_plugin_gtm_7e86d59a' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_cookieconsent_3dcc05f0 from 'nuxt_plugin_cookieconsent_3dcc05f0' // Source: ../../../plugins/cookie-consent.js (mode: 'all')
import nuxt_plugin_vueseo_21b54089 from 'nuxt_plugin_vueseo_21b54089' // Source: ../../../plugins/seo/vue-seo.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../../../plugins/axios.js (mode: 'all')
import nuxt_plugin_menu_6d1ad1fe from 'nuxt_plugin_menu_6d1ad1fe' // Source: ../../../plugins/menu/menu.js (mode: 'all')
import nuxt_plugin_vclipboardclient_6eaf7e67 from 'nuxt_plugin_vclipboardclient_6eaf7e67' // Source: ../../../plugins/v-clipboard.client.js (mode: 'client')
import nuxt_plugin_vuelazyload_d07c1d40 from 'nuxt_plugin_vuelazyload_d07c1d40' // Source: ../../../plugins/vue-lazyload.js (mode: 'all')
import nuxt_plugin_craftpreviewclient_21ff8503 from 'nuxt_plugin_craftpreviewclient_21ff8503' // Source: ../../../plugins/craft-preview.client.js (mode: 'client')
import nuxt_plugin_veevalidate_1a0c1998 from 'nuxt_plugin_veevalidate_1a0c1998' // Source: ../../../plugins/vee-validate.js (mode: 'all')
import nuxt_plugin_appheight_5d20df0e from 'nuxt_plugin_appheight_5d20df0e' // Source: ../../../plugins/app-height.js (mode: 'client')
import nuxt_plugin_vdragscrollclient_c42004e8 from 'nuxt_plugin_vdragscrollclient_c42004e8' // Source: ../../../plugins/v-dragscroll.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-MBC896N')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-MBC896N&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"],"css-variables":["innerHTML"]},"style":[{"hid":"css-variables","innerHTML":":root { --appHeight:100vh;--color-primary:#161313;--color-secondary:#FF5C28;--color-support-1:#59B4A6;--color-support-2:#F5EDE7;--color-lightest:#FFF;--color-darkest:#000;--color-text-dark:var(--color-primary);--color-gray-100:#F2F2F2;--color-gray-300:#CDCDCD;--color-gray-500:#707070;--color-gray-800:#313131;--color-shade-black-10:rgba(0, 0, 0, 0.1);--color-shade-black-30:rgba(0, 0, 0, 0.3);--color-shade-white-30:rgba(255, 255, 255, 0.3);--color-shade-white-80:rgba(255, 255, 255, 0.8);--color-highlight-success:#17C67C;--color-highlight-error:#ED3838;--transition-timing-slow:1s;--transition-timing-medium:500ms;--transition-timing-fast:250ms;--transition-timingFunction-in:cubic-bezier(0.4, 0, 1, 1);--transition-timingFunction-out:cubic-bezier(0, 0, 0.2, 1);--transition-timingFunction-in-out:cubic-bezier(0.4, 0, 0.2, 1);--transition-fast:var(--transition-timing-fast) 0ms var(--transition-timingFunction-in);--transition-medium:var(--transition-timing-medium) 0ms var(--transition-timingFunction-in);--transition-slow:var(--transition-timing-slow) 0ms var(--transition-timingFunction-in);--transition-collapse:50ms 0ms ease;--transition-link:250ms 0ms ease-out;--transition-page:200ms 0ms ease-in;--spacing-xs:.5rem;--spacing-sm:.9375rem;--spacing-md:1.25rem;--spacing-lg:1.5625rem;--spacing-xl:1.875rem;--spacing-2xl:2.5rem;--spacing-3xl:3.125rem;--spacing-4xl:3.75rem;--spacing-5xl:5rem;--spacing-6xl:7.5rem;--grid-side-gap-mobile:var(--grid-gap-mobile);--grid-side-gap-sm:var(--grid-gap-tablet);--grid-side-gap-lg:var(--grid-gap-desktop);--grid-gap-mobile:var(--spacing-lg);--grid-gap-tablet:var(--spacing-3xl);--grid-gap-desktop:var(--spacing-4xl);--grid-maxWidth-page:98rem;--grid-maxWidth-content:46.875rem;--borderRadius-sm:0.125rem;--borderRadius-md:0.25rem;--borderRadius-lg:0.5rem;--borderRadius-xl:0.75rem;--borderRadius-full:9999px;--boxShadow-light:0px 0px 8px rgba(0, 0, 0, 0.06);--boxShadow-base:0px 0px 6px rgba(0, 0, 0, 0.16);--boxShadow-heavy:0px 0px 16x rgba(0, 0, 0, 0.24);;--boxShadow-outline:0px 0px 12px rgba(0, 0, 0, 0.24);--font-family-primary:Stolzl web, sans-serif;--font-size-2xs:0.75rem;--font-size-xs:0.8125rem;--font-size-sm:0.875rem;--font-size-md:1rem;--font-size-lg:1.125rem;--font-size-xl:1.25rem;--font-size-2xl:1.5rem;--font-size-3xl:1.75rem;--font-size-4xl:2rem;--font-size-5xl:2.5rem;--font-size-6xl:4rem;--font-size-7xl:5rem;--font-weight-primary-book:300;--font-weight-primary-regular:400;--lineHeight-sm:1;--lineHeight-md:1.3;--lineHeight-lg:1.6; }"}]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6e56adae === 'function') {
    await nuxt_plugin_plugin_6e56adae(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_593d6dc4 === 'function') {
    await nuxt_plugin_axios_593d6dc4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_7921c0f7 === 'function') {
    await nuxt_plugin_pluginutils_7921c0f7(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_6db5ec82 === 'function') {
    await nuxt_plugin_pluginrouting_6db5ec82(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_23841e2d === 'function') {
    await nuxt_plugin_pluginmain_23841e2d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bugsnagclient49b55812_e84f55d8 === 'function') {
    await nuxt_plugin_bugsnagclient49b55812_e84f55d8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtpluginba874b4a_a485bdaa === 'function') {
    await nuxt_plugin_nuxtpluginba874b4a_a485bdaa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_fd2cfc40 === 'function') {
    await nuxt_plugin_workbox_fd2cfc40(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_0192e8f3 === 'function') {
    await nuxt_plugin_metaplugin_0192e8f3(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_063a8e67 === 'function') {
    await nuxt_plugin_iconplugin_063a8e67(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_7e86d59a === 'function') {
    await nuxt_plugin_gtm_7e86d59a(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieconsent_3dcc05f0 === 'function') {
    await nuxt_plugin_cookieconsent_3dcc05f0(app.context, inject)
  }

  if (typeof nuxt_plugin_vueseo_21b54089 === 'function') {
    await nuxt_plugin_vueseo_21b54089(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_menu_6d1ad1fe === 'function') {
    await nuxt_plugin_menu_6d1ad1fe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vclipboardclient_6eaf7e67 === 'function') {
    await nuxt_plugin_vclipboardclient_6eaf7e67(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelazyload_d07c1d40 === 'function') {
    await nuxt_plugin_vuelazyload_d07c1d40(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_craftpreviewclient_21ff8503 === 'function') {
    await nuxt_plugin_craftpreviewclient_21ff8503(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_1a0c1998 === 'function') {
    await nuxt_plugin_veevalidate_1a0c1998(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_appheight_5d20df0e === 'function') {
    await nuxt_plugin_appheight_5d20df0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vdragscrollclient_c42004e8 === 'function') {
    await nuxt_plugin_vdragscrollclient_c42004e8(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
